import { memo, useMemo, useState } from 'react';
import { cn, Collapse } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import useMedias from '@Hooks/useMedias';
import Button from '@UI/Button';
import IdeasGallery from './elements/OurWorkGallery';
import styles from './OurWork.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { OurWorksData } from '@Pages/PageExpressDesign/type';

export interface OurWorkProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  ourWorks: OurWorksData[];
}

const OurWork: FC<OurWorkProps> = (props) => {
  const { className, ourWorks, ...restProps } = props;
  const { isMobile } = useMedias();
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const ourWorksItems = useMemo(() => {
    if (isMobile) {
      return { main: ourWorks.slice(0, 3), secondary: ourWorks.slice(3) };
    }

    return { main: ourWorks.slice(0, 6), secondary: ourWorks.slice(6) };
  }, [isMobile, ourWorks]);

  return (
    <div {...restProps} className={className}>
      <div className={styles.title}>{t('our-works')}</div>

      <div>
        <IdeasGallery items={ourWorksItems.main} />
        {!isOpen && (
          <div className={styles.buttonWrapper}>
            <Button theme='transparent' onClick={() => setIsOpen(true)} className={styles.button}>
              {t('show-more')}
            </Button>
          </div>
        )}
        <Collapse collapsed={!isOpen} className={cn(styles.collapse, { [styles.isOpen]: isOpen })}>
          <IdeasGallery items={ourWorksItems.secondary} collapsed={true} />
        </Collapse>
      </div>
    </div>
  );
};

export default memo(OurWork);
